/** Personal History tab formatters (Angular #questionView parity). */

const TRUE_FLAGS = new Set(["1", "true", "yes", "y"])
const FALSE_FLAGS = new Set(["0", "false", "no", "n"])

/** Yes/No/"" from API flags (1/0, booleans, yes/no); "" when unset. */
export function formatYesNoFlag(value: unknown): "Yes" | "No" | "" {
  if (value === true) return "Yes"
  if (value === false) return "No"
  if (typeof value === "number") {
    if (value === 1) return "Yes"
    if (value === 0) return "No"
    return ""
  }
  if (typeof value === "string") {
    const lower = value.trim().toLowerCase()
    if (!lower) return ""
    if (TRUE_FLAGS.has(lower)) return "Yes"
    if (FALSE_FLAGS.has(lower)) return "No"
  }
  return ""
}

const BANKRUPTCY_TYPE_LABELS: Record<string, string> = {
  CHAPTER_7: "Chapter 7",
  CHAPTER_13: "Chapter 13",
  CHAPTER7: "Chapter 7",
  CHAPTER13: "Chapter 13",
}

/** Bankruptcy type code → label; "" when unknown (row hidden). */
export function formatBankruptcyTypeLabel(code: unknown): string {
  if (typeof code !== "string") return ""
  const key = code.trim().toUpperCase().replace(/[\s-]/g, "_")
  if (!key) return ""
  return BANKRUPTCY_TYPE_LABELS[key] ?? ""
}

/** "Is it Settled?" — Angular raw mapping, not inverted (#questionView). */
export function formatBankruptcySettledLabel(stillOpen: unknown): "Yes" | "No" | "" {
  return formatYesNoFlag(stillOpen)
}
